/* eslint-disable no-fallthrough */
/* eslint-disable import/prefer-default-export */
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * SD-1041
 * This file is used to configure settings for MSAL and the MFA process
 */
import { LogLevel } from '@azure/msal-browser';

export const b2cPolicies = {
  // the authentication type
  names: {
    signUpSignIn: 'b2c_1a_v2_signup_signin',
  },
  // the URL to use for each authentication type
  authorities: {
    signUpSignIn: {
      // eslint-disable-next-line prettier/prettier
      authority: 'https://login.sd.gov/d559d31b-362f-4c9f-9224-5de686942941/b2c_1a_v2_signup_signin',
    },
  },
  // the top level domain
  authorityDomain: 'login.sd.gov',
};

export const msalConfig = {
  // Configuration for SSO endpoints and redirects
  auth: {
    // the id we present for the tenant
    clientId: '018068a8-724c-4dbc-a9ef-9aa92277b6fe',
    authority: 'https://login.sd.gov/d559d31b-362f-4c9f-9224-5de686942941/b2c_1a_v2_signup_signin',
    authorize:
      'https://login.sd.gov/d559d31b-362f-4c9f-9224-5de686942941/b2c_1a_v2_signup_signin/oauth2/v2.0/authorize',
    token_endpoint:
      'https://login.sd.gov/d559d31b-362f-4c9f-9224-5de686942941/b2c_1a_v2_signup_signin/oauth2/v2.0/token',

    // The URI to be redirected to after the login process
    // ONLY USE LOCALHOST WHEN TESTING ON LOCAL. NEVER COMMIT THIS FILE IF
    // LOCALHOST IS BEING USED.
    redirectURI: 'https://dev-ua.sdeeservices.com',
    // redirectURI: 'https://dev1-ua.sdeeservices.com/',
    // redirectUri: 'https://localhost:3000',
    knownAuthorities: ['login.sd.gov'],
  },
  // Configuration for SSO parameters
  loginRequest: {
    code_challenge:
      'YTFjNjI1OWYzMzA3MTI4ZDY2Njg5M2RkNmVjNDE5YmEyZGRhOGYyM2IzNjdmZWFhMTQ1ODg3NDcxY2Nl',
    code_challenge_method: 'plain',
    scope: 'openid',
    response_type: 'code',
    response_mode: 'query',
    grant_type: 'authorization_code',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false, // Prefer false, only set to true if
    // having issues on edge or ie11
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);

          default:
        }
      },
    },
  },
};
